export const headers = [
  { key: '_id', label: 'Workflow Handler ID' },
  { key: 'status', label: 'Current Status' },
  { key: 'viewDetails', label: 'View Details' }
];
